export default {
    id: "skb-kontur-partnership-2026",
    articleType: "release",
    slug: "sotrudnichestvo-skb-kontur-innoprom-2026",
    date: "8 июля 2026",
    dateTime: "2026-07-08",
    modifiedTime: "2026-07-08",
    author: "Редакция «Светофор Логистика»",
    category: "Партнёрства · 2026",
    contentType: "Новость",
    title:
        "«Светофор Логистика» и СКБ Контур подписали соглашение о стратегическом сотрудничестве",
    sidebarTitle: "Стратегическое соглашение со СКБ Контур",
    seoTitle:
        "«Светофор Логистика» и СКБ Контур: стратегическое сотрудничество",
    seoDescription:
        "На ИННОПРОМ-2026 «Светофор Логистика» и СКБ Контур подписали соглашение о сотрудничестве для развития единой цифровой логистической экосистемы.",
    image:
        "/img/news/sotrudnichestvo-skb-kontur-innoprom-2026/cover.webp",
    imageAlt:
        "Подписание соглашения между «Светофор Логистика» и СКБ Контур на ИННОПРОМ-2026",
    gallery: [
        {
            src:
                "/img/news/sotrudnichestvo-skb-kontur-innoprom-2026/photo-02.webp",

            thumbnail:
                "/img/news/sotrudnichestvo-skb-kontur-innoprom-2026/photo-02-thumb.webp",
            alt:
                "Представитель СКБ Контур выступает на церемонии подписания соглашения",
        },
        {
            src:
                "/img/news/sotrudnichestvo-skb-kontur-innoprom-2026/photo-03.webp",

            thumbnail:
                "/img/news/sotrudnichestvo-skb-kontur-innoprom-2026/photo-03-thumb.webp",
            alt:
                "Подписание соглашения о сотрудничестве между СКБ Контур и «Светофор Логистика»",
        },
        {
            src:
                "/img/news/sotrudnichestvo-skb-kontur-innoprom-2026/photo-04.webp",

            thumbnail:
                "/img/news/sotrudnichestvo-skb-kontur-innoprom-2026/photo-04-thumb.webp",
            alt:
                "Представители СКБ Контур и «Светофор Логистика» на ИННОПРОМ-2026",
        },
        {
            src:
                "/img/news/sotrudnichestvo-skb-kontur-innoprom-2026/photo-05.webp",

            thumbnail:
                "/img/news/sotrudnichestvo-skb-kontur-innoprom-2026/photo-05-thumb.webp",
            alt:
                "Выступление после подписания стратегического соглашения на ИННОПРОМ-2026",
        },
    ],
    content: {
        subtitle: "Соглашение подписано на выставке ИННОПРОМ-2026",
        lead: [
            "«Светофор Логистика» и СКБ Контур подписали стратегическое соглашение, направленное на развитие умной и адаптивной логистической экосистемы.",
            "Компании объединят технологические наработки и отраслевую экспертизу, чтобы сделать цифровые процессы в логистике более прозрачными и бесшовными.",
        ],
        sections: [
            {
                icon: "🤝",
                title: "О партнёре",
                paragraphs: [
                    "СКБ Контур — федеральная экосистема сервисов для бизнеса. Компания развивает решения для электронного документооборота, бухгалтерии, проверки контрагентов, информационной безопасности и других рабочих процессов.",
                    "Сервисами Контура пользуются более 3,1 млн компаний в России и за рубежом.",
                ],
            },
            {
                icon: "⚙️",
                title: "Основные цели партнёрства",
                items: [
                    {
                        title: "Оптимизация документооборота",
                        text: "Сокращение бумажной рутины и ускорение оформления сделок.",
                    },
                    {
                        title: "Единое цифровое окно",
                        text: "Интеграция управления рейсами, аналитики и ЭДО в одной платформе.",
                    },
                    {
                        title: "Прозрачность операций",
                        text: "Отслеживание логистических процессов в реальном времени.",
                    },
                    {
                        title: "Синергия экспертизы",
                        text: "Объединение опыта Контура в цифровых сервисах и практических компетенций «Светофор Логистика» в управлении цепочками поставок.",
                    },
                ],
            },
            {
                icon: "💡",
                title: "Что это значит для рынка",
                paragraphs: [
                    "Сотрудничество создаёт основу для более тесной интеграции цифровых сервисов, электронных документов и управления перевозками.",
                    "Цель партнёрства — дать участникам рынка надёжные ИТ-инструменты для работы без лишней бумажной нагрузки и скрытых операционных рисков.",
                ],
            },
        ],
        galleryTitle: "Фотографии с подписания соглашения",
    },
};
